import { bootstrapApplication } from '@angular/platform-browser';
import { appConfig } from './app/app.config';
import { App } from './app/app';
import { registerLocaleData } from '@angular/common';
import localeEs from '@angular/common/locales/es';
import * as Sentry from '@sentry/angular';
import { environment } from './environments/environment';
import { scrubEvent } from './app/core/utils/sentry-scrub.util';

if (environment.sentryDsn) {
  Sentry.init({
    dsn: environment.sentryDsn,
    environment: environment.name,
    tracesSampleRate: environment.name === 'production' ? 0.2 : 1.0,
    beforeSend: scrubEvent,
  });
}

registerLocaleData(localeEs);

bootstrapApplication(App, appConfig)
  .catch((err) => console.error(err));
